var map = {
	"./2co.png": "b09b",
	"./alipay.png": "9a22",
	"./alipay2.png": "e37a",
	"./amazon.png": "1d41",
	"./american_express.png": "45ab",
	"./american_express_black.png": "1c34",
	"./american_express_gold.png": "1b84",
	"./american_express_green.png": "5252",
	"./american_express_platinum.png": "31c6",
	"./asia_pay.png": "9ff4",
	"./asia_pay2.png": "94c5",
	"./bank_of_america.png": "9ea5",
	"./cash.png": "4adb",
	"./cashu.png": "a8c1",
	"./chase.png": "7cd4",
	"./check.png": "872c",
	"./china_union.png": "f8fa",
	"./cirrus.png": "2c7a",
	"./cirrus2.png": "2467",
	"./citybank.png": "68c7",
	"./clickandbuy.png": "64a2",
	"./credit_card.png": "6a78",
	"./credit_cards.png": "3857",
	"./currency_baht_sign.png": "359f",
	"./currency_bitcoin_sign.png": "3e73",
	"./currency_denar_sign.png": "57fa",
	"./currency_dinar_sign.png": "c1b1",
	"./currency_dollar_sign.png": "9a41",
	"./currency_dollar_sign2.png": "d3f3",
	"./currency_euro_sign.png": "0b74",
	"./currency_peso_sign.png": "3e5d",
	"./currency_pound_sign.png": "1c0a",
	"./currency_rial_sign.png": "e65b",
	"./currency_ruble_sign.png": "285c",
	"./currency_rupee_sign.png": "de1c",
	"./currency_sign.png": "83d8",
	"./currency_yen_sign.png": "d5dd",
	"./currency_yen_sign2.png": "cdc2",
	"./currency_yuan_sign.png": "a7a5",
	"./diners_club.png": "f351",
	"./discover.png": "4f14",
	"./e_check.png": "aeac",
	"./electroncash.png": "5a0a",
	"./eps.png": "8ce8",
	"./gift_card.png": "8ecd",
	"./giropay.png": "7785",
	"./google_wallet.png": "f42b",
	"./jcb.png": "f3f6",
	"./maestro.png": "0857",
	"./maestro2.png": "b4ac",
	"./mastercard.png": "4c77",
	"./mastercard2.png": "3c2e",
	"./mastercard_gold.png": "7380",
	"./mastercard_platinum.png": "70ce",
	"./obopay.png": "94f4",
	"./paymate.png": "b9f7",
	"./paymate2.png": "76ac",
	"./paypal.png": "d8ea",
	"./purchase_order.png": "6984",
	"./skrill.png": "9f01",
	"./transferwise.png": "3485",
	"./ukash.png": "207e",
	"./visa.png": "2754",
	"./visa_electron.png": "1a73",
	"./visa_gold.png": "c680",
	"./visa_platinum.png": "5a5b",
	"./webmoney.png": "2d007",
	"./western_union.png": "e8a0",
	"./wire_transfer.png": "1746",
	"./worldpay.png": "9cd7",
	"./xoom.png": "0417"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "30d6";